
















































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class UyapBirimAktarim extends Vue {
  dosya: File | null = null;
  onizleme: any = null;
  sonuc: any = null;
  hata: string = "";

  yukleniyor: boolean = false;
  aktariliyor: boolean = false;
  onayDialog: boolean = false;
  sekme: number = 0;

  secilenDoldurulacak: any[] = [];
  secilenYeni: any[] = [];
  secilenKapatilacakIsim: any[] = [];
  secilenKapatilacakListe: any[] = [];

  // Her kutucuk sayının yanında NE OLACAĞINI da yazar; operatör sekmeleri
  // gezmeden uygulamanın sonucunu bu satırdan görebilmeli.
  kovalar = [
    { anahtar: 'doldurulacak', baslik: 'Birim kimliği doldurulacak', etki: 'mevcut kayda kimlik yazılır',
      metin: 'success--text', zemin: 'green lighten-5' },
    { anahtar: 'yeni', baslik: 'Bizde olmayan', etki: 'aktif kayıt açılır',
      metin: 'primary--text', zemin: 'blue lighten-5' },
    { anahtar: 'kapatilacak', baslik: 'Kapatılacak', etki: 'kapatılmış işaretlenir, silinmez',
      metin: 'orange--text text--darken-3', zemin: 'orange lighten-5' },
    { anahtar: 'catisma', baslik: 'Çatışma', etki: 'elle karar gerekir',
      metin: 'error--text', zemin: 'red lighten-5' },
    { anahtar: 'belirsiz', baslik: 'Belirsiz', etki: 'elle karar gerekir',
      metin: 'orange--text text--darken-3', zemin: 'orange lighten-5' },
    { anahtar: 'eslesen', baslik: 'Zaten eşleşmiş', etki: 'değişiklik gerekmiyor',
      metin: 'grey--text text--darken-2', zemin: 'grey lighten-4' },
  ];

  doldurulacakBasliklar = [
    { text: "UYAP birim kimliği", value: "uyap_birim_id" },
    { text: "UYAP adı", value: "uyap_adi" },
    { text: "Bizdeki kayıt", value: "icra_dairesi_id" },
    { text: "İsim farkı", value: "ad_farkli", sortable: false },
    { text: "İl", value: "il_adi" },
  ];
  yeniBasliklar = [
    { text: "UYAP birim kimliği", value: "uyap_birim_id" },
    { text: "UYAP adı", value: "uyap_adi" },
    { text: "Şehir", value: "sehir_id" },
    { text: "Adliye", value: "adliye_adi" },
  ];
  kapatilacakBasliklar = [
    { text: "Kayıt", value: "icra_dairesi_id" },
    { text: "İsim", value: "isim" },
    { text: "İl", value: "il_adi" },
  ];
  kapatilacakListeBasliklar = [
    { text: "Kayıt", value: "icra_dairesi_id" },
    { text: "İsim", value: "isim" },
    { text: "İl", value: "il_adi" },
    { text: "Not", value: "olasi_karsilik", sortable: false },
  ];
  eslesenBasliklar = [
    { text: "UYAP birim kimliği", value: "uyap_birim_id" },
    { text: "UYAP adı", value: "uyap_adi" },
    { text: "Bizdeki kayıt", value: "icra_dairesi_id" },
    { text: "İl", value: "il_adi" },
  ];
  sonucBasliklar = [
    { text: "Durum", value: "durum" },
    { text: "UYAP birim kimliği", value: "uyap_birim_id" },
    { text: "UYAP adı", value: "uyap_adi" },
    { text: "Açıklama", value: "aciklama" },
  ];

  get elleKararToplam(): number {
    if (!this.onizleme) return 0;
    return this.onizleme.catisma.length + this.onizleme.belirsiz.length;
  }

  get kapatilacakToplam(): number {
    if (!this.onizleme) return 0;
    return this.onizleme.kapatilacak.isaretli.length + this.onizleme.kapatilacak.listede_yok.length;
  }

  get kapatilacakSecili(): number {
    return this.secilenKapatilacakIsim.length + this.secilenKapatilacakListe.length;
  }

  /** Yeni kayıt açma kararı artık satır seçiminin kendisi. */
  get yeniKayitEkle(): boolean {
    return this.secilenYeni.length > 0;
  }

  get secilenToplam(): number {
    return this.secilenDoldurulacak.length + this.secilenYeni.length + this.kapatilacakSecili;
  }

  onizlemeyiTemizle() {
    this.onizleme = null;
    this.sonuc = null;
    this.hata = "";
    this.secilenDoldurulacak = [];
    this.secilenYeni = [];
    this.secilenKapatilacakIsim = [];
    this.secilenKapatilacakListe = [];
  }

  async onizle() {
    if (!this.dosya) return;
    this.yukleniyor = true;
    this.hata = "";
    this.sonuc = null;

    try {
      const metin = await this.dosyayiOku(this.dosya);
      let veri: any;
      try {
        veri = JSON.parse(metin);
      } catch (e) {
        throw new Error("Dosya geçerli bir JSON değil.");
      }

      const yanit = await this.$http.post(
          this.$store.state.icwApiUrl + 'admin/uyap-birim/onizleme',
          { data: { veri }, sendJson: true }
      );
      this.onizleme = yanit.data;
      // Varsayılan: doldurulacakların hepsi seçili (güvenli işlem),
      // yeni kayıtlar seçili DEĞİL (banka/vergi bilgisi eksik açılıyorlar).
      this.secilenDoldurulacak = this.onizleme.doldurulacak.slice();
      // Yeni kayıtlar da işaretli gelir; pasif açıldıkları ve ürün listelerine
      // girmedikleri için ayrı bir onay kutusuna gerek yok — satır seçimi ve onay
      // penceresi kararı zaten alıyor.
      this.secilenYeni = this.onizleme.yeni.slice();
      // Kapatılacakların ikisi de işaretli gelir (kullanıcı kararı, 03.09.2026);
      // gerekirse operatör tek tek işareti kaldırır.
      this.secilenKapatilacakIsim = this.onizleme.kapatilacak.isaretli.slice();
      this.secilenKapatilacakListe = this.onizleme.kapatilacak.listede_yok.slice();
      this.sekme = 0;
    } catch (e) {
      this.hata = this.hataMesaji(e, "Önizleme başarısız oldu.");
    } finally {
      this.yukleniyor = false;
    }
  }

  async aktar() {
    this.aktariliyor = true;
    this.hata = "";

    const birimler = this.secilenDoldurulacak
        .concat(this.yeniKayitEkle ? this.secilenYeni : [])
        .map((r: any) => ({
          uyap_birim_id: r.uyap_birim_id,
          uyap_adi: r.uyap_adi,
          il_kodu: r.il_kodu,
        }));

    const kapatilacaklar = this.secilenKapatilacakIsim
        .concat(this.secilenKapatilacakListe)
        .map((r: any) => r.icra_dairesi_id);

    try {
      const yanit = await this.$http.post(
          this.$store.state.icwApiUrl + 'admin/uyap-birim/aktar',
          {
            data: { birimler, yeni_kayit_ekle: this.yeniKayitEkle, kapatilacaklar },
            sendJson: true
          }
      );
      this.sonuc = yanit.data;
      this.onayDialog = false;
      this.$emit('aktarildi');
      // Uygulanan satırlar artık başka kovaya düştüğü için önizleme bayat kaldı.
      this.onizleme = null;
      this.secimiTemizle();
    } catch (e) {
      this.hata = this.hataMesaji(e, "Aktarım başarısız oldu.");
      this.onayDialog = false;
    } finally {
      this.aktariliyor = false;
    }
  }

  secimiTemizle() {
    this.secilenDoldurulacak = [];
    this.secilenYeni = [];
    this.secilenKapatilacakIsim = [];
    this.secilenKapatilacakListe = [];
  }

  /** Sonuç panelinden yeni bir dosyaya geçiş; ekranı ilk hâline döndürür. */
  bastanBasla() {
    this.dosya = null;
    this.sonuc = null;
    this.onizlemeyiTemizle();
  }

  durumEtiketi(durum: string): string {
    if (durum === 'guncellendi') return 'güncellendi';
    if (durum === 'olusturuldu') return 'yeni kayıt';
    if (durum === 'kapatildi') return 'kapatıldı';
    if (durum === 'hata') return 'hata';
    return 'atlandı';
  }

  durumRengi(durum: string): string {
    if (durum === 'guncellendi') return 'success';
    if (durum === 'olusturuldu') return 'primary';
    if (durum === 'kapatildi') return 'orange darken-2';
    if (durum === 'hata') return 'error';
    return '';
  }

  private dosyayiOku(dosya: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const okuyucu = new FileReader();
      okuyucu.onload = () => resolve(String(okuyucu.result));
      okuyucu.onerror = () => reject(new Error("Dosya okunamadı."));
      okuyucu.readAsText(dosya);
    });
  }

  /** Axios hatasi, JSON hatasi veya duz Error olabilir; okunur tek mesaja indirger. */
  hataMesaji(e: any, varsayilan: string): string {
    const sunucu = e && e.response && e.response.data ? e.response.data.message : null;
    return sunucu || (e && e.message) || varsayilan;
  }
}
